export function footer() {
    if (!$('.footer-social').length) {
        $('.footer .copy').css('margin-bottom', 'auto');
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/footer.js